<template>
    <div>
       <div class='account' @click='$router.push("/favourites")'>
            <i class="fa-light fa-location-dot icon"></i>
       </div>
    </div>
</template>

<style lang="scss" scoped>

.account{
    cursor: pointer;
}

.icon{
    font-size: 1.4rem;

    @media(max-width:768px){
        font-size: 1.2rem;
    }
}

</style>